'use client';

import { twMerge } from '@shared/themes';
import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';

type NotificationDotProps = ComponentProps<'div'> & {
  className?: string;
};

function NotificationDot({ className, children, ...props }: NotificationDotProps) {
  const t = useTranslations('header.notifications');

  return (
    <div className={twMerge('flex items-center justify-center rounded-full bg-notification-red box-content h-2 w-2', className)} aria-label={t('new_notification')} {...props}>
      {children}
    </div>
  );
}

export { NotificationDot, type NotificationDotProps };
